
import { useContext, useEffect, useState } from 'react';
import './login.css';
import { Link } from 'react-router-dom';
import RightLoginRegister from '../../components/rightLoginRegister/RightLoginRegister';
import { AuthContext } from '../../context/authContext/AuthContext';
import { login } from '../../context/authContext/apiCalls';
import FormInput from '../../components/formInput/FormInput';
import { restartAuth } from '../../context/authContext/AuthActions';

function Login() {
  const [errorBox, setErrorBox] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { isFetching, dispatch, error } = useContext(AuthContext);

  useEffect(() => {
    if (error != false) {
      setErrorBox(error);
    }
  }, [error])

  const loginHandler = (e) => {
    e.preventDefault();
    login(dispatch, { username, password });
    dispatch(restartAuth());
  }

  return (
    <div className="container">
      <div className="box">
        <div className="logo">
          <img src="/logo.png" alt="" />
        </div>
        <form action="">
          <h1>Se Connecter</h1>

          {errorBox !== "" && (<div className='box-error'>{errorBox}</div>)}

          <FormInput label='Username *' itemInput={username} setItemInput={setUsername} auth />
          <FormInput label='Password *' itemInput={password} setItemInput={setPassword} auth isPassword />

          <button onClick={loginHandler} style={isFetching ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
            <span>{isFetching ? "Se Connecter ..." : "Se Connecter"}</span>
          </button>
          <p>
            Vous n'avez pas un compte ? <Link to={"/register"}>Créer un Compte</Link>
          </p>
        </form>
      </div>

      <RightLoginRegister />
    </div>
  )
}
export default Login